import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { GetGa4UserResponse } from './domains';

@Injectable({
  providedIn: 'root',
})
export class Ga4DataService {
  readonly #http = inject(HttpClient);

  private static readonly baseURL = environment.classi_api_url;

  getGa4User(): Observable<{ ga4_user: GetGa4UserResponse }> {
    return this.#http.get<{ ga4_user: GetGa4UserResponse }>(`${Ga4DataService.baseURL}/ga4_user`);
  }
}
